import React from 'react';
import JobItem from './../JobItem';

const Index = props => {
	const { jobs } = props;
	return (
		<div className='job-list flex flex-col py-2'>
			{jobs && jobs.length > 0 ? jobs.map(job => <JobItem job={job} />) : []}
		</div>
	);
};

export default Index;
